module.exports = __webpack_public_path__ + "img/44.62f256ca.jpg";